import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environments';

@Component({
  selector: 'app-footer',
  imports: [CommonModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  contactPath = environment.contactUs;
  startYear = 2025;
  currentYear = new Date().getFullYear();

  constructor(public router: Router) {}

  get copyrightText(): string {
    return this.currentYear > this.startYear
      ? `Copyright © ${this.startYear} - ${this.currentYear}`
      : `Copyright © ${this.startYear}`;
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }
  openContact(link: string, target: string = '') {
    window.open(link, target);
  }
}
